import Comments from "../Comments";
import VideoBlock from "../VideoBlock";
import DailySchedule from "../DailySchedule";
import Divider from "components/common/Divider";
import { accent400 } from "constantVariables";
import PrimaryButton from "components/common/Button/PrimaryButton";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import { t } from "i18next";
// import CalenderPlaceholder from "assets/icons/CalenderPlaceholder";
// import CareerVideoPlaceholder from "assets/icons/CareerVideoPlaceholder";

export default function Suggestion({ lastSlide, activeCareer, parent }) {
  const { dir, language } = useAppSelector(getSettings);
  const { tabHandler } = useLifeChoicePageContext();

  
  if (parent !== activeCareer._id) return "";
  return (
    <div
      className={`containter bg-theme-blue rounded-tl-2xl rounded-tr-2xl ${
        lastSlide ? "rounded-bl-2xl rounded-br-2xl" : ""
      }`}
    >
      <div
        className="flex flex-col lg:flex-row pt-14 pb-7 lg:pt-32 lg:pb-12"
        dir={dir}
      >
        <div className="w-full lg:w-1/2 px-4 lg:px-14 rtl:border-l ltr:border-r rtl:border-l-theme-purple ltr:border-r-theme-purple h-full">
          <h3 className="text-3xl font-medium text-white">
            {activeCareer.title[language]}
          </h3>
          <p className="text-white font-extralight mt-1">
            {activeCareer?.description[language]}
          </p>
          <div className="flex flex-wrap gap-1 lg:gap-3 items-center mt-10">
            <div className="flex gap-3 items-center">
              <p className="text-sm flex items-center gap-2 text-white lg:ml-0">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11.234"
                  height="11.234"
                  viewBox="0 0 11.234 11.234"
                >
                  <path
                    id="time"
                    d="M8.992,3.375a5.617,5.617,0,1,0,5.617,5.617A5.617,5.617,0,0,0,8.992,3.375Zm2.593,6.481H8.992a.432.432,0,0,1-.432-.432V5.535a.432.432,0,0,1,.864,0V8.992h2.16a.432.432,0,1,1,0,.864Z"
                    transform="translate(-3.375 -3.375)"
                    fill="#fff"
                  />
                </svg>
                {t("positionDuration")}
              </p>
              <p className="text-sm font-semibold text-white">
                {activeCareer.avg_duration.value}
                &nbsp;
                {activeCareer.avg_duration.duration_type[language]}
              </p>
            </div>
            <div className="flex gap-3 items-center ml-0 lg:ml-12">
              <p className="text-sm flex items-center gap-2 text-white">
                <span className="text-bold">$</span>
                {t("avgSalary")}
              </p>
              <p className="text-sm font-semibold text-white">
                {activeCareer.salary.monthly_avg_il}
              </p>
            </div>
          </div>
          <Divider height={1} fill="#5A70E8" className="mt-3" />
          {activeCareer && activeCareer.calendar_id && !Array.isArray(activeCareer.calendar_id) ? (
            <div className={`my-6 lg:mt-20  career-desktop-schedule`}>
              <DailySchedule calender={activeCareer.calendar_id} />
            </div>
          ) : (
            ''
            // <div className="my-6 lg:mt-20">
            //   <CalenderPlaceholder className="lg:max-w-lg max-w-xs h-fit mx-auto" />
            // </div>
          )}
        </div>
        <div className="w-full lg:w-1/2 px-4 lg:px-14 h-full">
          {activeCareer && activeCareer.video ? (
            <div className={"lg:max-w-lg mx-auto"}>
              <VideoBlock videoUrl={activeCareer?.video} />
            </div>
          ) : (
            ''
            // <div className={""}>
            //   <CareerVideoPlaceholder className="lg:max-w-sm max-w-xs w-fit h-fit mx-auto" />
            // </div>
          )}
          {(activeCareer && activeCareer.reviews.length) ? (
            <>
              <h3 className="text-xl font-semibold text-white mt-5">
                {t("careerTabReviewsTitleText")}
              </h3>
              <Comments
                title={activeCareer.title}
                items={activeCareer.reviews}
                slidesPerView={1}
              />
            </>
          ) : ""}
          <div className="max-w-sm w-full mx-auto mt-10">
            <h3 className="text-2xl font-semibold text-white text-center mb-6">
              {t("thinkRightPathForYou")}
            </h3>
            <PrimaryButton
              color={accent400}
              onClick={() => tabHandler("apply")}
              className="rounded-lg py-3 w-full text-xl"
            >
              {t("applyNowButton")}
            </PrimaryButton>
          </div>
        </div>
      </div>
      {activeCareer?.next_careers.length > 0 ? (
        <div className="pb-7 lg:pb-12">
          <p className="text-white text-3xl font-medium w-full text-center">
            {t("whatsNext")}
          </p>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
